import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { OrganisationService } from '@services/organisations/organisation.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-organisations',
    templateUrl: './organisations.component.html',
    styleUrls: ['./organisations.component.scss'],
    providers: [OrganisationService],
    standalone: false
})
export class OrganisationsComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  public title = 'Organisations';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title' }
  ];

  constructor(
    public organisationService: OrganisationService,
    public dialogService: DialogService,
    private router: Router,
  ) {
  }

  ngOnInit() {

    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Organisation',
        callback: () => {
          this.router.navigate(['organisations/create']);
        }
      })
    ];
  }

  public onEdit(event: DataTableEvent) {
    this.router.navigate(['organisations', event.row.OrganisationID, 'edit']);
  }

  public onRemove(event: DataTableEvent) {
    this.dialogService
      .confirm('Remove organisation?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.organisationService.remove(event.row.OrganisationID).then(() => {
          this.table.refresh();
        }).catch(error => {
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

}
